// based on rc-collapse 1.10.2
import CollapsePanel from './src/Panel';
import Collapse from './src/Collapse';
import { collapseProps, panelProps } from './src/commonProps';

Collapse.Panel = CollapsePanel;

export { collapseProps, panelProps };
export default Collapse;
